import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "assets-check-create-modal-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalInfo.modalConfig.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalInfo.modalConfig.visible) = $event)),
      width: "600px",
      title: _ctx.modalInfo.modalConfig.modalTitle,
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalInfo.closeModal()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          bordered: "",
          colon: true,
          column: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "模板名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.recordData.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "模板编码" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.recordData.code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "模板签名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.recordData.signName), 1)
              ]),
              _: 1
            }),
            (_ctx.recordData.itemList.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.recordData.itemList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_descriptions_item, {
                    key: index,
                    label: `细项${index+1}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.key) + "(" + _toDisplayString(item.value) + ") ", 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_a_descriptions_item, { label: "模板内容" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.recordData.template), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}